<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('meta.history') }}</h3>
    </header>
    <div class="content-body">
      <div v-if="versionsData.length == 0" class="alert alert-danger">{{ $t('meta.noHistory') }}</div>
      <div v-else>
        <Table>
          <template #header>
            <th>{{ $t('meta.changedAt') }}</th>
            <th>{{ $t('meta.changedBy') }}</th>
            <th>{{ $t('meta.changed') }}</th>
          </template>
          <template #body>
            <tr v-for="version in versionsData" :key="version.id">
              <td>{{ formattedFromDateTime(version.created_at) }}</td>
              <td>{{ version.whodunnit }}</td>
              <td><HistoryChanges :changes="version.object_changes" /></td>
            </tr>
          </template>
        </Table>
        <div class="pagination">
          <pagination
            :records="paginationData.totalObjects"
            v-model="paginationData.page"
            :per-page="paginationData.perPage"
            @paginate="getVersionsData"
            :options="{ chunk: 5, texts: { count: $t('pagination.text') } }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'

import HistoryChanges from '@/components/Table/HistoryChanges.vue'
import Table from '@/components/Table/index.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'History',
  components: {
    HistoryChanges,
    Pagination,
    Table,
  },
  mixins: [dateUtils],
  props: {
    history: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      versionsData: this.history.versions,
      paginationData: this.history.pagination,
    }
  },
  watch: {
    history: {
      immediate: true,
      handler(newVal) {
        if (newVal.versions) this.versionsData = newVal.versions
        if (newVal.pagination) this.paginationData = newVal.pagination
      },
      deep: true,
    },
  },
  methods: {
    getVersionsData(page) {
      this.$emit('getVersionsData', page)
    },
  },
}
</script>
